import React, { FunctionComponent } from "react";
import { Helmet } from "react-helmet-async";

import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";

export const ScriptOrbee: FunctionComponent = () => {
  const dealer = useNullableDealerAccountInfo();

  if (!dealer?.dealerRetailSiteOrbeeAnalyticsCode) {
    return null;
  }

  return (
    <>
      <Helmet>
        <script type="text/javascript">
          {`
            (function(w,d,n){
              w.orbObject=w.orbObject||n;
              if(!w[n]){
                w[n]=function(){
                  return (w[n].q=w[n].q||[]).push(arguments)
                };
                w[n].q=w[n].q||[];
              }
            })(window,document,"orb");
          `}
        </script>
        <script
          async
          defer
          src={`//scripts.orb.ee/tms.js?sid=${dealer?.dealerRetailSiteOrbeeAnalyticsCode}`}
        />
      </Helmet>
    </>
  );
};
